<template>
  <v-stepper v-model="step" vertical non-linear>
    <v-stepper-step step="1" complete editable>
      Website Development LifeCycle
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-card class="mb-12 ">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Stage</th>
                <th class="text-left">Date</th>
                <th class="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in lifecycle" :key="item.name">
                <td>{{ item.name }}</td>
                <td>{{ item.date }}</td>
                <td>{{ item.status }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-stepper-content>

    <v-stepper-step step="2" complete editable>Site Details</v-stepper-step>

    <v-stepper-content step="2">
      <v-card class="mb-12">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>Template Name</td>
                <td>{{ main_order.template }}</td>
              </tr>
              <tr>
                <td>Technology</td>
                <td>{{ main_order.technology }}</td>
              </tr>
              <tr>
                <td>Site Type</td>
                <td>{{ main_order.type }}</td>
              </tr>
              <tr>
                <td>Domain Name</td>
                <td>{{ main_order.domain_name }}</td>
              </tr>
              <tr>
                <td>Order ID</td>
                <td>{{ main_order.order_id }}</td>
              </tr>
              <tr>
                <td>Total Amount</td>
                <td>{{ main_order.total_amount }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ main_order.email }}</td>
              </tr>
              <tr>
                <td>Password</td>
                <td>{{ main_order.password }}</td>
              </tr>
              <tr>
                <td>SMTP Settings</td>
                <td>{{ main_order.smtp }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-stepper-content>

    <v-stepper-step step="3" complete editable>Raise Request</v-stepper-step>

    <v-stepper-content step="3">
      <v-card class="mb-12 scroll">
        <v-flex xs6 sm6>
          <v-select
            v-model="requestRaised"
            :items="request"
            label="Raise a request"
            color="primary"
          ></v-select>
          <v-text-field
            v-model="comments"
            label="Details about the request raised"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs4 sm4 align-center>
          <v-btn rounded color="primary" @click="submitRequest"> Submit </v-btn>
        </v-flex>
      </v-card>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
import { db } from "@/Firebase";
import { functions } from "@/Firebase";
export default {
  name: "OrderWebsiteDetails",
  data: () => ({
    temp: [],
    main_order: {},
    noParam: false,
    comments: "",
    msg: "",
    step: 1,
    dialog: false,
    featureSelected: [],
    lifecycle: [],
    request: ["Add/Delete Pages", "Add Forms", "Customize Website", "Others"],
    requestRaised: ""
  }),
  props: {
    order: {
      type: Object
    }
  },
  mounted() {
    if (this.$route.query.id == null) window.location.href = "/orders-website";
    else {
      if (this.$route.params.order == null) {
        let docRef = db.collection("orders").doc(this.$store.getters.userId);
        docRef
          .collection("website")
          .doc(this.$route.query.id)
          .get()
          .then(doc => {
            this.main_order = doc.data();
            this.lifecycle = this.main_order.lifecycle;
          })
          .catch(function(error) {
            alert("Error getting order details:", error);
          });
      } else {
        this.main_order = this.$route.params.order;
        this.lifecycle = this.main_order.lifecycle;
      }
      if (this.main_order.technology == "Wordpress") {
        for (var i = 0; i < 15; i++) {
          if (this.main_order.features.includes(i))
            this.featureSelected.push(this.wordpress[i + 1].text);
        }
      }
    }
  },
  methods: {
    addFeature(id) {
      if (this.featureSelected.includes(id))
        this.totalAmount += this.wordpress[id - 1].price;
      else this.totalAmount -= this.wordpress[id - 1].price;
    },
    submitRequest() {
      let raiseRequest = functions.httpsCallable("raiseRequest");
      raiseRequest({
        requestRaised: this.requestRaised,
        comments: this.comments,
        uid: this.$store.state.userId,
        wid: this.$route.query.id
      })
        .then(() => {
          this.msg = "Request Successfully raised";
          alert(this.msg);
        })
        .catch(function(error) {
          alert("Error submitting requests:", error);
        });
    }
  }
};
</script>
<style scoped>
.scroll {
  overflow-y: auto;
}
</style>
